import React from 'react';
import { Link } from 'react-router-dom';
import './style.scss';

function Button({type="button", to, color, size="small", children, className, ...rest}) {
  if (type === "link" || to !== undefined) return (
    <Link
      to={to}
      className={`button button__${color} button__${size} ${className ?? ""}`}
      {...rest}
    >
      {children}
    </Link>
  );
  const Tag = type;
  return (
    <Tag
      className={`button button__${color} button__${size} ${className ?? ""}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default Button;
